import gsap from 'gsap';

export default {
  created() {
  },
  methods: {
    panBackground(elem, moveLeft) {
      var demoCalc = window.getComputedStyle(elem).getPropertyValue('background-position');
      const backgroundPos = demoCalc.replace('px', '').split(' ');
      const bgPosX = parseInt(backgroundPos[0]);
      const bgPosY = parseInt(backgroundPos[1]);
      gsap.timeline({
          repeat: -1,
          yoyo: true,
          repeatDelay: 1,
        }).to(
          elem, 5, 
          { 
            backgroundPosition: (bgPosX-moveLeft)+"px " +(bgPosY)+"px",
            ease: "sine.inOut"
          }
        );

    }    
  }
}
